import { createKubbApiClient } from '../kubb-api-client';
export * from '../kubb-api-client';

export const axiosClient = getWebAppBffApiClient()

export function getWebAppBffApiClient({
  path
}: {
  path?: string;
} = {}) {
  return createKubbApiClient('web-app-bff',
  (import.meta.env.VITE_ENV.startsWith('prod') ?  'https://web-api.mediainbox.io' : 'https://web-api-dev.mediainbox.io') + (path ? `/${path}` : '')
);
}

export default axiosClient;
